import React, { useEffect } from 'react';

import { Image, ImageProps } from '@mantine/core';
import brandDark from 'assets/images/brand_dark.png';
import brandLight from 'assets/images/brand_light.png';
import logoDark from 'assets/images/logo_dark.png';
import logoLight from 'assets/images/logo_light.png';

interface BrandingProps extends ImageProps {
  isLight?: boolean;
  avatar?: boolean;
}

export function Branding({ isLight = false, avatar = false, ...imageProps }: BrandingProps) {
  const style = {
    transform: 'translateZ(0)',
    transition: 'opacity 0.2s ease',
    '&:hover': {
      cursor: 'pointer'
    }
  } as const;

  // Preload images to prevent flickering
  useEffect(() => {
    const images = [logoLight, logoDark, brandLight, brandDark];
    images.forEach((src) => {
      const img = new window.Image();
      img.src = src;
    });
  }, []);

  return avatar ? (
    <Image sx={style} {...imageProps} src={isLight ? logoLight : logoDark} />
  ) : (
    <Image sx={style} {...imageProps} src={isLight ? brandLight : brandDark} />
  );
}
